import React, { useState } from 'react';
import { Button } from "@/components/ui/button";
import { Download, Loader2 } from 'lucide-react';
import * as XLSX from 'xlsx';
import { base44 } from '@/api/base44Client';

export default function ExportQueryToExcel({ data, sqlQuery, className }) {
  const [exporting, setExporting] = useState(false);

  const handleExport = async () => {
    if (!data || !Array.isArray(data) || data.length === 0) return;
    setExporting(true);

    try {
      // Get current user info
      let userName = 'Unknown';
      let userEmail = 'Unknown';
      try {
        const user = await base44.auth.me();
        userName = user?.full_name || 'Unknown';
        userEmail = user?.email || 'Unknown';
      } catch (_) {}

      const wb = XLSX.utils.book_new();

      // Tab 1: Data
      const dataSheet = XLSX.utils.json_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, dataSheet, 'Results');

      // Tab 2: Query Info
      const now = new Date();
      const timestamp = now.toLocaleString('en-US', {
        dateStyle: 'full',
        timeStyle: 'long'
      });

      const infoRows = [
        ['HexDB Query Export'],
        [],
        ['Exported At', timestamp],
        ['Requested By', `${userName} (${userEmail})`],
        ['Rows Returned', String(data.length)],
        [],
        ['SQL Query'],
        [sqlQuery || 'N/A']
      ];

      const infoSheet = XLSX.utils.aoa_to_sheet(infoRows);
      // Widen columns for readability
      infoSheet['!cols'] = [{ wch: 20 }, { wch: 80 }];
      XLSX.utils.book_append_sheet(wb, infoSheet, 'Query Info');

      // Download
      const filename = `HexDB_Export_${now.toISOString().slice(0, 19).replace(/[T:]/g, '-')}.xlsx`;
      XLSX.writeFile(wb, filename);
    } catch (err) {
      console.error('Excel export failed:', err);
    } finally {
      setExporting(false);
    }
  };

  return (
    <Button
      size="sm"
      variant="ghost"
      onClick={handleExport}
      disabled={exporting}
      className={`h-6 px-2 text-[10px] text-emerald-300 hover:text-emerald-100 hover:bg-emerald-500/20 ${className || ''}`}
    >
      {exporting ? <Loader2 className="w-3 h-3 mr-1 animate-spin" /> : <Download className="w-3 h-3 mr-1" />}
      {exporting ? 'Exporting...' : 'Export to Excel'}
    </Button>
  );
}